import script from "./AudioWasabiComp.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioWasabiComp.vue?vue&type=script&setup=true&lang=js"

import "./AudioWasabiComp.vue?vue&type=style&index=0&id=0a011fec&lang=css"

const __exports__ = script;

export default __exports__